import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/prApprovalMatrix",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "prApprovalMatrix-page",
        component: () =>
          import("@/views/PRApprovalMatrix/PRApprovalMatrixPage.vue"),
        meta: {
          title: "PR Approval Matrix",
          titleLocalizationCode: "PR_Approval_Matrix",
          desc: "PR approval matrix page",
          descLocalizationCode: "PR_Approval_Matrix_Page",
          sidebarElement: false,
          permissionCodes: [
            "PR_ApprovalMatrix.Read",
            "PR_ApprovalMatrix.Add",
            "PR_ApprovalMatrix.Edit",
            "PR_ApprovalMatrix.Delete",
          ],
        },
      },
    ],
  },
];
